/**
 * The account menu's look, shared by the menu and its language rows.
 *
 * Classes for kit `DropdownMenu*` parts: they override the kit's compact
 * defaults with the hub's rounder, roomier panel. `cn` in the kit merges them,
 * so a later utility here replaces the kit's one of the same kind.
 */

/** The dropdown panel. */
export const MENU_PANEL = "rounded-2xl border-border bg-card p-1.5 shadow-lg";

/** One row: a link, a screen of this hub, or a language. */
export const MENU_ROW =
  "cursor-pointer gap-2.5 rounded-full px-3 py-[7px] text-[12.75px] font-medium text-foreground focus:bg-accent/60 focus:text-foreground";

/** A row's leading icon. */
export const MENU_ICON = "size-4 shrink-0 text-muted-foreground";

/** The line between groups of rows. */
export const MENU_SEP = "mx-0 my-1.5";
